import capitalize from "lodash-es/capitalize";

import HistoryEntryWrapper from "components/Run/elements/HistoryEntryWrapper";
import HistoryEntryNote from "components/Run/elements/HistoryEntryNote";

import { RunHistoryEntryType } from "../../types";

type SkippedEntryProps = {
  note: string | null;
  timestamp: number;
};

const SkippedEntry = ({ note, timestamp }: SkippedEntryProps) => {
  return (
    <HistoryEntryWrapper state={RunHistoryEntryType.Skipped} timestamp={timestamp} terminal>
      {note && <HistoryEntryNote>{capitalize(note)}</HistoryEntryNote>}
    </HistoryEntryWrapper>
  );
};

export default SkippedEntry;
